import { useMediaQuery, useTheme } from '@mui/material';

export const useMedia = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isWidescreen = useMediaQuery(theme.breakpoints.up('xl'));

  return {
    isDesktop,
    isTablet,
    isMobile,
    isWidescreen,
  };
};
